export default __webpack_public_path__ + "static/media/booking-logo.e20f68da.svg";